export class Centerlink {
    Id : Number;
	CentreId : Number;
	GroupId : Number;
	CustomerId : Number;
	LeaderId : Number;
	LeaderName : string;
	MeetingDay : string;
	AdmissionFee : Number;
	EmployeeId : Number;
	EmployeeBranchId : Number;
	CompanyId : Number;
	SaasId : Number;
	CreatedDate : Date;
	ModifiedDate : Date;
	IsActive: boolean;
    Flag: Number;

	BranchId:Number ; //  for filtering centre by BranchId
}
